import React from "react";
import "./Thank.css";

const ThankYouPage = () => {
  return (
    <div className="thankYouContainer">
      <div className="thankYouMessage">
        <h1>Thank You for Placing Your Trust in SSA</h1>
        <p>
          We sincerely thank you for your payment. Your Super Smart Agent is now
          under production! Please give us 2-3 days as we carefully design and
          fine-tune it to meet your expectations. As soon as your agent is
          primed and ready to assist, we'll notify you via email with all
          pertinent details and next steps. Your trust and dedication to our
          services inspire us to uphold the highest standards. Be confident that
          we are dedicated to providing you with an exceptional experience.
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
